/**
 * @author Evgeny Shevtsov, info@sitespring.ru
 * @homepage https://sitespring.ru
 * @licence Proprietary
 */
export const KEY_ORDER_ALLOWED_DELIVERY_DAYS = 'order.allowedDeliveryDays';
export const KEY_ORDER_PHONE_NOTIFICATIONS = 'order.phoneNotifications';
export const KEY_ORDER_EMAIL_NOTIFICATIONS = 'order.emailNotifications';
export const KEY_ORDER_ALLOWED_DELIVERY_DAYS_WITH_THRESHOLDS = 'order.allowedDeliveryDaysWithThresholds';
export const KEY_ORDER_SMS_DELIVERY_TEMPLATE = 'order.smsDeliveryTemplate';